import * as queryString from "query-string";
import http from "../httpConfig";
import {
  AddGroupPayload,
  GetManagePortsPayload,
  AddNrsInGroupPayload,
  UnGroupNrsPayload,
  UpdateGroupPayload,
  PutupForSalePayload,
  EditSalePayload,
  RemoveFromMarketPlacePayload,
  cancelSubPayload,
  setRequestVerificationPayload,
  editNRPayload,
  deleteOffNetPortPayload,
} from "../interfaces/managePorts.interface";
import { API_PATHS_NEW, ApiPath } from "../utils/apiConstants";
import { getAuthHeader } from "../utils/methods";

const getPortsAndGroups = (expandedNeId: string, searchText: string, sortField: string, sortDirection: string) => {
  const url = queryString.stringifyUrl({
    url: ApiPath.group + ApiPath.nrList,
    query: {
      neId: expandedNeId,
      searchText,
      sortField,
      sortDirection,
    },
  });
  return http.get(url, { headers: getAuthHeader() });
};

const addGroupDetails = (payload: AddGroupPayload) => {
  return http.post(ApiPath.group, payload, { headers: getAuthHeader() });
};

const addNrsInExistingGroup = (payload: AddNrsInGroupPayload) => {
  const url = queryString.stringifyUrl({ url: `${ApiPath.group}/${payload.groupId}` });

  return http.put(url, { nrIds: payload.nrIds, purchasePortIds: payload.purchasePortIds, neId: payload.neId }, { headers: getAuthHeader() });
};

const updateGroupDetails = (payload: UpdateGroupPayload) => {
  const url = queryString.stringifyUrl({ url: `${ApiPath.group}/${payload.groupId}` });

  return http.put(
    url,
    {
      name: payload.name,
      description: payload.description,
      icon: payload.icon,
      neId: payload.neId,
    },
    { headers: getAuthHeader() }
  );
};

const getAllGroupsByNEid = (neId: string, type: "port" | "bandwidth" | "") => {
  const url = queryString.stringifyUrl({ url: ApiPath.group, query: { neId, type } });

  return http.get(url, { headers: getAuthHeader() });
};

const unGroupNrs = (payload: UnGroupNrsPayload) => {
  const url = queryString.stringifyUrl({ url: `${ApiPath.group}/${payload.groupId}` });
  // @ts-ignore
  return http.patch(url, { nrIds: payload.nrIds, purchasePortIds: payload.purchasePortIds }, { headers: getAuthHeader() });
};

const putUpForSale = (payload: PutupForSalePayload) => {
  return http.post(ApiPath.putForSale, payload, { headers: getAuthHeader() });
};

const editSaleDetails = (payload: EditSalePayload, nrId: string) => {
  const url = queryString.stringifyUrl({ url: `${ApiPath.putForSale}/${nrId}` });
  return http.put(url, payload, { headers: getAuthHeader() });
};

const removeFromMarketPlace = (payload: RemoveFromMarketPlacePayload) => {
  const url = queryString.stringifyUrl({ url: `${ApiPath.putForSale}/${payload.nrId}` });
  return http.patch(url, {}, { headers: getAuthHeader() });
};

const cancelSubscription = (payload: cancelSubPayload) => {
  const url = queryString.stringifyUrl({ url: ApiPath.cancelSubscription });
  return http.put(url, payload, { headers: getAuthHeader() });
};

const setRequestVerification = (payload: setRequestVerificationPayload) => {
  const url = queryString.stringifyUrl({ url: ApiPath.setRequestVerification });
  return http.put(url, payload, { headers: getAuthHeader() });
};

const requestMoveToMMR = (payload: { nrId: number }) => {
  const url = queryString.stringifyUrl({ url: API_PATHS_NEW.requestMoveToMMR });
  return http.put(url, payload, { headers: getAuthHeader() });
};

const moveToLeasedSwitch = (payload: { nrId: number; positionInNe: number }) => {
  return http.post(API_PATHS_NEW.moveToLeasedSwitch, payload, { headers: getAuthHeader() });
};
const removeFromLeasedSwitch = (payload: { nrId: number }) => {
  return http.post(API_PATHS_NEW.removeFromLeasedSwitch, payload, { headers: getAuthHeader() });
};

const movePositionOnLeasedSwitch = (payload: { nrId: number; positionInNe: number }) => {
  return http.post(API_PATHS_NEW.movePositionOnLeasedSwitch, payload, { headers: getAuthHeader() });
};

const getAvailablePositionsOnLeasedSwitch = (payload: { nrId: number }) => {
  const url = queryString.stringifyUrl({ url: API_PATHS_NEW.getAvailablePositionsOnLeasedSwitch, query: payload });
  return http.get(url, { headers: getAuthHeader() });
};

const editNR = (payload: editNRPayload) => {
  const url = queryString.stringifyUrl({ url: ApiPath.editNR });
  return http.put(url, payload, { headers: getAuthHeader() });
};

const getManagePortsList = (payload: GetManagePortsPayload) => {
  const url = queryString.stringifyUrl({ url: `${ApiPath.networkResources}${ApiPath.getManagePortsList}`, query: payload });
  return http.get(url, { headers: getAuthHeader() });
};

const deleteOffNetPort = (payload: deleteOffNetPortPayload) => {
  const url = queryString.stringifyUrl({ url: ApiPath.deleteOffNetPort });
  return http.put(url, payload, { headers: getAuthHeader() });
};

const getPortsInGroup = (payload: { neId: number; isBandwidth: boolean; groupId: number }) => {
  const url = queryString.stringifyUrl({ url: API_PATHS_NEW.getPortsInGroup, query: payload });
  return http.get(url, { headers: getAuthHeader() });
};

const ManagePortsService = {
  deleteOffNetPort,
  getPortsAndGroups,
  getManagePortsList,
  addGroupDetails,
  addNrsInExistingGroup,
  getAllGroupsByNEid,
  unGroupNrs,
  updateGroupDetails,
  putUpForSale,
  editSaleDetails,
  removeFromMarketPlace,
  cancelSubscription,
  setRequestVerification,
  editNR,
  moveToLeasedSwitch,
  getAvailablePositionsOnLeasedSwitch,
  movePositionOnLeasedSwitch,
  removeFromLeasedSwitch,
  getPortsInGroup,
  requestMoveToMMR,
};

export default ManagePortsService;
